<template>
  <CWarrantyIcon :status :size/>
  <CEllipsis v-if="!compact">
    {{ $t(label) }}
  </CEllipsis>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CEllipsis from '@/shared/components/CEllipsis.vue';
  import WarrantyStatus from '../constants/WarrantyStatus';
  import CWarrantyIcon from './CWarrantyIcon.vue';

  const props = withDefaults(defineProps<{
    status: WarrantyStatus;
    size?: number;
    compact?: boolean;
  }>(), {
    size: 18,
  });

  const label = computed(() => {
    switch (props.status) {
      case WarrantyStatus.NO_WARRANTY:
        return 'warrantyStatus.none';
      case WarrantyStatus.AWAITING:
        return 'warrantyStatus.awaiting';
      case WarrantyStatus.PARTIAL:
        return 'warrantyStatus.partial';
      case WarrantyStatus.WARRANTY:
        return 'warrantyStatus.full';
      case WarrantyStatus.SERVICE_CONTRACT:
        return 'warrantyStatus.serviceContract';
    }
  });
</script>